// extracted by mini-css-extract-plugin
export default {"save-bar":"Profile_save-bar__0DXAl"};